module.exports = " <h6>O seu browser est&aacute; desatualizado!</h6> <p>Atualize o seu browser para ter uma melhor experi&ecirc;ncia e visualiza&ccedil;&atilde;o deste site. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/pt>Atualize o seu browser agora</a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Fechar>&times;</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./outdated-browser/lang/pt.html
// module id = 821
// module chunks = 2